// extracted by mini-css-extract-plugin
export var menuItem = "F_t8 d_fW d_bw d_bz d_bL d_bb";
export var menuItemSub = "F_t9 d_W d_bw d_bL";
export var menuMainLink = "F_vb d_fX d_dx";
export var menuLink = "F_vc d_fX d_dx";
export var Link = "F_sr x_sr x_rM x_r5";